import {
  formatPlanEntitlementFeatures,
  type PlanId,
} from "@reelmagic/domain";

export function formatBillingPrice(amount: number | null, currency: string) {
  if (amount === null) {
    return "Pending";
  }

  return new Intl.NumberFormat("en-US", {
    currency: currency.toUpperCase(),
    maximumFractionDigits: 0,
    style: "currency",
  }).format(amount / 100);
}

/** Shared by landing, billing, and upgrade plan cards. */
export const PLAN_BENEFITS = [
  "Create ready-to-post faceless videos in minutes",
  "Generate proven viral formats",
  "Reel editor suite to tweak your content",
] as const;

export const PLAN_FEATURES: Record<Exclude<PlanId, "free">, string[]> = {
  starter: [
    "1,400 credits per month",
    ...formatPlanEntitlementFeatures("starter"),
    ...PLAN_BENEFITS,
  ],
  creator: [
    "3,000 credits per month",
    ...formatPlanEntitlementFeatures("creator"),
    ...PLAN_BENEFITS,
  ],
  pro: [
    "6,500 credits per month",
    ...formatPlanEntitlementFeatures("pro"),
    ...PLAN_BENEFITS,
  ],
};

export const PLAN_STANDARD_REEL_COPY: Record<Exclude<PlanId, "free">, string> = {
  starter: "~25-35 standard reels",
  creator: "~55-75 standard reels",
  pro: "~120-165 standard reels",
};

export const PLAN_AI_VIDEO_REEL_COPY: Record<Exclude<PlanId, "free">, string> = {
  starter: "~4-5 AI video reels",
  creator: "~8-12 AI video reels",
  pro: "~19-26 AI video reels",
};
